import styled from '@emotion/styled';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import {
  Autocomplete,
  FormControl,
  InputLabel,
  Paper,
  Select,
  Switch,
  TextField,
} from '@mui/material';

const Card = ({ card, setData, ...props }) => {
  function handleEditSelected(val) {
    setData(prev => ({
      ...prev,
      value: prev.value.map(i => {
        if (i.guid === card.guid) {
          return {
            ...i,
            selectedValue: val,
            showInDisplay: val.value?.length && val.value !== 'هیچکدام',
          };
        } else {
          return i;
        }
      }),
    }));
  }

  function changeShowInDisplay(e) {
    setData(prev => ({
      ...prev,
      value: prev.value.map(i => {
        if (i.guid === card.guid) {
          return { ...i, showInDisplay: e.target.checked };
        } else {
          return i;
        }
      }),
    }));
  }

  return (
    <CardContainer square>
      <OpenWithIcon fontSize="large" />
      <FormControl
        sx={{
          'maxWidth': '350px',
          '& *': {
            textAlign: 'right !important',
          },
        }}
        fullWidth
      >
        <Autocomplete
          dir="rtl"
          options={card.values}
          autoHighlight
          value={card.selectedValue || null}
          getOptionLabel={option => option.value}
          noOptionsText={
            <div className="w-full flex justify-center">موردی یافت نشد</div>
          }
          renderOption={(args, option) => (
            <div {...args} style={{ textAlign: 'right', width: '100%' }}>
              {option.value}
            </div>
          )}
          onChange={(event, newValue) => {
            handleEditSelected(newValue ?? '');
          }}
          ListboxProps={{
            sx: {
              direction: 'rtl',
              textAlign: 'right',
            },
          }}
          sx={{
            '.MuiInputBase-root': {
              paddingRight: '9px !important',
            },
            '.MuiOutlinedInput-root': {
              direction: 'rtl',
            },
            '.MuiOutlinedInput-notchedOutline legend': {
              textAlign: 'right',
            },
          }}
          renderInput={params => (
            <TextField
              {...params}
              sx={{
                '.MuiInputLabel-root': {
                  left: 'inherit !important',
                  right: '1.75rem !important',
                  transformOrigin: 'top right !important',
                },
                '.MuiAutocomplete-endAdornment': {
                  right: 'unset !important',
                  left: '9px',
                },
                '.MuiAutocomplete-endAdornment button': {
                  mr: 0.5,
                },
                'textAlign': 'right',
              }}
              name={card.guid}
              label={card?.display}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
              className="gray-icon"
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
      </FormControl>
      <Switch
        color="primary"
        name="showInDisplay"
        id="showInDisplay"
        checked={!!card.showInDisplay}
        onChange={changeShowInDisplay}
        aria-labelledby="showInDisplay"
      />
    </CardContainer>
  );
};

const CardContainer = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  width: 100%;
  padding: 8px;
  background-color: rgb(245, 245, 245);
`;

export default Card;
